import { Lockr } from "@/common/Lockr";
import { StorageKeys } from "@/common/constants/storageKeys";
import { app as microsoftApp } from "@microsoft/teams-js";
import { SignInResult } from "@/repository/models";

export const tryGetTokens = () => {
	const token = Lockr.get(StorageKeys.TokenId);
	const tenantId = Lockr.get(StorageKeys.TenantId);

	if (!token || !tenantId) {
		return null;
	}

	return {
		tokenId: token,
		tenantId: tenantId,
	};
};

export const storeUserInfo = (userInfo: microsoftApp.UserInfo) => {
	const msUserId = userInfo?.id || "";
	const azureTenantId = userInfo?.tenant?.id || "";
	const userPrincipalName = userInfo?.userPrincipalName || "";

	Lockr.set(StorageKeys.MsUserObjectId, msUserId);
	Lockr.set(StorageKeys.TIDForAzure, azureTenantId);
	Lockr.rm(StorageKeys.ServiceCallTimeout);

	localStorage.setItem(StorageKeys.UPN, userPrincipalName);
	localStorage.setItem(StorageKeys.UPNForAzure, userPrincipalName);
	localStorage.setItem(StorageKeys.TIDForAzure, azureTenantId);
};

export const getBrowserSessionIdOrCreate = (): string => {
	const currentBrowserSessionId = sessionStorage.getItem(
		StorageKeys.BrowserSessionId
	) as string;

	if (!!currentBrowserSessionId) {
		return currentBrowserSessionId;
	}

	const newBrowserSessionId = new Date().getTime().toString();
	sessionStorage.setItem(StorageKeys.BrowserSessionId, newBrowserSessionId);

	return newBrowserSessionId;
};

export const storeLoginData = (data: SignInResult) => {
	localStorage.setItem(StorageKeys.UPN, data.upn || "");

	Lockr.set(StorageKeys.TokenId, data.jwt || "");
	Lockr.set(StorageKeys.SIP, data.upn.toLowerCase() || "");
	Lockr.set(StorageKeys.CompanyId, data.tenantId || "");
	Lockr.set(StorageKeys.TenantId, data.tenantId || "");
	Lockr.set(StorageKeys.UserId, data.userId || "");
	Lockr.set(StorageKeys.FullName, data.fullName || "");
	Lockr.set(
		StorageKeys.SessionExpiryTimestamp,
		data.sessionExpiryTimestamp || 0
	);
};

export const cleanTeamsTokens = () => {
	for (const key in localStorage) {
		if (
			key.includes("authority") &&
			key.includes("scopes") &&
			key.includes("homeAccountIdentifier")
		) {
			localStorage.removeItem(key);
		}
	}
};

export const embededInTeams = new URLSearchParams(window.location.search).get("stage3");
